var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization"},[_c('h1',{staticClass:"head"},[_vm._v("架構及成員")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.association.structure)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }